<template>
  <div class="file-list">
    <b-modal :active.sync="fileModal.active" has-modal-card>
      <file-modal
        :file.sync="fileModal.file"
        :model.sync="fileModal.model"
        :model-id.sync="fileModal.modelId"
        accept=".png, .jpg, .jpeg, .gif, .xls, .xlsx, .doc, .docx, .pdf, .csv"
        :viewers="viewers"
        :fileToDisplay="fileToDisplay"
        :accepted-mime-types="[
          'image/png',
          'image/jpeg',
          'image/gif',
          'application/vnd.ms-excel',
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          'application/msword',
          'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
          'application/pdf',
          'text/csv'
        ]"
        @uploaded="fetch"
        @updated="fetch"
        @deleted="fetch"
      />
    </b-modal>
    <div class="columns">
      <!-- When a model is known, we're looking for files against that specific model only. -->
      <div v-if=" ! this.model" class="column is-narrow">
        <b-field>
          <b-select placeholder="Type" v-model="uploadableType">
              <option value="">All</option>
              <option v-for="(type, i) in uploadable_types" :key="`uploadable_type_option_${i}`" :value="type.value">{{ type.label }}</option>
          </b-select>
        </b-field>
      </div>
      <div class="column is-narrow">
        <b-field>
          <b-input
            placeholder="Search"
            type="search"
            icon="search"
            v-model="search"
          />
        </b-field>
      </div>
      <div v-if="!this.model" class="column is-narrow">
        <b-field>
          <b-input
            placeholder="Per page"
            v-model="perPage"
          />
        </b-field>
      </div>
      <div class="column">
        <p class="control">
          <b-button @click="() => fetch()">Search</b-button>
        </p>
      </div>
      <div class="column is-6" v-if="!noUpload">
        <div class="pull-right">
          <b-button @click="() => openFileModal()" :disabled="disabled">
            UPLOAD
          </b-button>
        </div>
      </div>
    </div>

    <div class="columns">

        <div :class="'column ' + (viewer || form ? 'is-6' : '')">
            
            <base-table
              :service="$options.fileService"
              :fetchParams="params"
              fetch-func="all"
              :columns="columns"
              sticky
              :height="tableHeight"
              detailed
              @fetch="onTableFetch"
              ref="filesTable"
              focusable
              :selectable="selectable"
              :selected.sync="selected"
              @click="onTableClick"
            >
              <template #rowThumbnail="{ row }">

                <div class="is-inline-block" style="min-width: 128px">
                  
                  <figure class="image">

                    <!-- <a :href="row.path" target="_blank"> -->

                      <img :src="row.thumbnail" v-if="row.mime.includes('image')" class="thumbnail-image" />
                      
                      <b-icon :icon="getIconByMimeType(row.mime)" size="is-large" v-else/>
                      
                    <!-- </a> -->
                  
                  </figure>

                </div>
              
              </template>
              
              <!-- row type slot -->
              <template #rowType="{ row }">
                {{ row.name && row.name.type ? row.name.type : "" }}
              </template>
              <!-- row owner slot -->
              <template #rowOwner="{ row }">
                {{ row.name && row.name.owner ? row.name.owner : "" }}
              </template>
              <!-- row created at slot -->
              <template #rowCreatedAt="{ row }">
                {{ row.createdAt | toLocalDateAndTime }}
              </template>
              <!-- row actions slot -->
              
              <template #rowActions="{ row }">
                <b-button :disabled="disabled" @click="openFileModal(row)">
                  UPDATE
                </b-button>

                <a :href="row.path" class="button" style="color: black;" target="_blank" :ref="row.id" v-if="!form && !viewer">DOWNLOAD</a>
              </template>

              <!-- detail slot -->
              <template #detail="{ row }">


                <article class="media">
                  <div class="media-content">
                    <div class="content">
                      <strong>Description</strong>
                      <p>{{ row.description || "N/A" }}</p>
                      <strong>Tags</strong>
                      <b-taglist v-if="row.tags && row.tags.length">
                        <b-tag v-for="tag in row.tags" :key="tag.id" type="is-dark">
                          {{ tag.name }}
                        </b-tag>
                      </b-taglist>
                      <p v-else>N/A</p>
                    </div>
                  </div>
                </article>

              </template>

            </base-table>

        </div>

        <div class="column is-6" v-show="! selected" v-if="hasChart">
          <file-chart />
        </div>

        <div class="column is-6" v-if="(viewer || form) && selected">
            <!-- <b-loading :active="loading.active" :is-full-page="loading.fullpage"></b-loading> -->
            
            <div v-if="selectedFile.source" style="display: flex; align-items: center; justify-content: center">
              <a :href="selectedFile.source" target="_blank" v-if="selectedFile.type == 'image'">
                <img :src="selectedFile.source" alt="" style="max-height: 350px">
              </a>
              <iframe
                :src="fileToDisplay"
                frameborder="0"
                style="height: 350px; width:100%"
                v-else-if="fileToDisplay"
              />
            </div>

            <!-- <iframe src="https://docs.google.com/gview?url=https://file-examples.com/wp-content/uploads/2017/02/file_example_XLSX_100.xlsx&embedded=true"></iframe> -->

            <div class="" v-if="selected && form">
            
                  <file-modal
                    :file.sync="fileModal.file"
                    :model.sync="fileModal.model"
                    :model-id.sync="fileModal.modelId"
                    accept=".png, .jpg, .jpeg, .gif, .xls, .xlsx, .doc, .docx, .pdf, .csv"
                    :modal="false"
                    :viewers="viewers"
                    :accepted-mime-types="[
                      'image/png',
                      'image/jpeg',
                      'image/gif',
                      'application/vnd.ms-excel',
                      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                      'application/msword',
                      'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                      'application/pdf',
                      'text/csv'
                    ]"
                    @uploaded="fetch"
                    @updated="fetch"
                    @deleted="fetch"
                  />

            </div>


        </div>

    </div>

  </div>

</template>

<script>
import BaseTable from "@/components/partials/BaseTable";
import FileModal from "./FileModal";
import FileIframe from "./FileIframe";
import FileChart from "./FileChart";
import { FileService } from "@/services/file.service";
import { TagService } from "@/services/tag.service";
import { JsonDenormalizer } from "@/helpers/JsonDenormalizer";

export default {
  fileService: FileService,
  columns: [
    { field: "thumbnail", centered: true, meta: { rowSlot: "rowThumbnail" } },
    { field: "id", label: "ID", sortable: true },
    {
      field: "type",
      label: "Owner Type",
      sortable: false,
      meta: { rowSlot: "rowType" }
    },
    {
      field: "owner",
      label: "Owner",
      sortable: false,
      meta: { rowSlot: "rowOwner" }
    },
    { field: "subtype", label: "Type" },
    {
      field: "createdAt",
      label: "Created At",
      meta: { rowSlot: "rowCreatedAt" }
    },
    {
      field: "createdBy",
      label: "Created By",
      meta: { valuePath: "createdBy.fullName" }
    },
    {
      field: "actions",
      label: "Actions",
      sortable: false,
      centered: true,
      meta: { rowSlot: "rowActions" }
    }
  ],
  props: {
    model: {},
    modelType: {
      type: String
    },
    height: {
      type: Number,
      default: 500
    },
    disabled: {
      type: Boolean,
      default: false
    },
    viewer: {
      type: Boolean,
      default: false
    },
    form: {
      type: Boolean,
      default: false
    },
    hasChart: {
      type: Boolean,
      default: false
    },
    selectable: {
      type: Boolean,
      default: false
    },
    noUpload: {
      type: Boolean,
      default: false,
    },
    listModels: {
      type: Array,
    }
  },
  components: {
    BaseTable,
    FileModal,
    FileIframe,
    FileChart,
  },
  data: () => ({
    search: "",
    uploadableType: "",
    uploadable_types: [
      { value: 'firm', label: 'Firm' },
      { value: 'order', label: 'Order' },
      { value: 'person', label: 'Person' },
      { value: 'geojson', label: 'GeoJSON' },
      { value: 'form_response', label: 'Form Response' },
    ],
    perPage: 1000,
    columns: [],
    fileModal: {
      active: false,
      file: undefined,
      model: undefined,
      modelId: undefined
    },

    selectedFile: {
        type: '',
        source: ''        
    },

    selected:null,

    viewers:[],

    fileToDisplay: '',

    loading: {
        active: true,
        fullpage: false
    }
 
  }),
  computed: {
    tableHeight() {
      return this.height - 45; // columns
    },
    params() {
      let params = {
        includes: "createdBy",
        keyword: this.search,
        // uploadableType: this.uploadableType,
        per_page: this.perPage,
      };

      if (this.listModels) {
        params.uploadables = this.listModels;
      } else if (this.model) {
        params.uploadableId = this.model.id;
        params.uploadableType = this.model.model_type;
      }

      if (this.uploadableType) {
        params.uploadableType = this.uploadableType;
      }

      // if (this.modelType) {
      //   this.uploadableType = this.modelType;
      // }

      return params;
    }
  },
  created() {
    this.setColumns();
  },
  mounted() {
    this.fetch();
    this.getTags();
  },
  watch: {
    model: {
      handler() {
        this.$nextTick(() => {
          this.fetch();
        });
      },
      deep: true
    },

    selected(file) {

      this.fileToDisplay = '';

      if (file) {
        
        this.fileData(file);

        let mime = this.getIconByMimeType(file.mime);

        this.selectedFile.source = file.path;

        switch(mime) {

            case 'file-image-o':  this.selectedFile.type = 'image'; break;

            default: 

            this.selectedFile.type = mime;
            
            this.findFile(this.selectedFile);
        
        }

      }else {
        
        this.selectedFile.source = '';

        this.selectedFile.type = '';

      }

    }

  },
  methods: {

    async imgUrlAlt(row, event) {

      let id = row.id > 1000 ? row.id.substring(row.id.length -3) : row.id;

      if (event.target.className == 'thumbnail-image') {

        event.target.src = row.path
  
        event.target.className = "main-image"

        let data = {

          id: parseInt(id),
          
          name: row.filename,

          path: row.path,

          // path: 'https://halcyon-general.s3.us-west-1.amazonaws.com/2020-05-22/329_281_25231-thumbnail.png?X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIASKJYQAOXJXVYY6FJ%2F20200522%2Fus-west-1%2Fs3%2Faws4_request&X-Amz-Date=20200522T074700Z&X-Amz-SignedHeaders=host&X-Amz-Expires=86400&X-Amz-Signature=7ae717648d87197f00484c716adc6df3d32d0f743001c02a1c1f709fc138a549',

        };

        await FileService.generatethumbnail(data);

      } else if(event.target.className == 'main-image'){

        event.target.src = 'https://i.picsum.photos/id/'+parseInt(id)+'/300/300.jpg';

        event.target.className = "generated-image"

      } else{
        
        id = row.id > 1000 ? row.id.substring(row.id.length -2) : row.id;

        event.target.src = 'https://i.picsum.photos/id/'+parseInt(id)+'/300/300.jpg';
        
        // event.target.src = 'https://bitsofco.de/content/images/2018/12/Screenshot-2018-12-16-at-21.06.29.png';

        // event.target.className = "generated-image"

        // event.target.parentElement.href = 'javascript:;'

        // event.target.parentElement.target = ''

        // this.$refs[row.id].href = 'javascript:;'

        // this.$refs[row.id].target = ''

        // this.$refs[row.id].className = 'button invalid-download'

      }

    }, 

    async fetch(file = null) {

      await this.$refs.filesTable.fetchData();

      this.selected = file;

    },
    setColumns() {
      this.columns = this.$options.columns.reduce((acc, column) => {
        if (["type", "owner"].includes(column.field)) {
          if (this.model && this.modelType) {
            return acc;
          }
        }

        acc.push(column);

        return acc;
      }, []);
    },
    openFileModal(file = null) {

      // console.log(file);

      this.fileModal.active = true;
      // this.fileModal.active = true;

      // if (file) {
      //   let model = file.uploadableType;

      //   model = model.split("\\");
      //   model = model[model.length - 1].toLowerCase();

      //   this.fileModal.file = file;
      //   this.fileModal.model = model;
      //   this.fileModal.modelId = file.uploadableId;
      // } else {
      //   this.fileModal.file = undefined;
      //   this.fileModal.model = this.modelType || undefined;
      //   this.fileModal.modelId = this.model ? this.model.id : undefined;
      // }

      this.fileData(file);

    },
    fileData(file = null){

        if (file) {
            let model = file.uploadableType;

            model = model.split("\\");
            model = model[model.length - 1].toLowerCase();

            this.fileModal.file = file;
            this.fileModal.model = model;
            this.fileModal.modelId = file.uploadableId;
        } else {
            this.fileModal.file = undefined;
            this.fileModal.model = this.modelType || undefined;
            this.fileModal.modelId = this.model ? this.model.id : undefined;
        }

    },
    getIconByMimeType(mime) {
      if (mime.includes("image")) {
        return "file-image-o";
      } else if (mime.includes("pdf")) {
        return "file-pdf-o";
      } else if (mime.includes("msword") || mime.includes("word")) {
        return "file-word-o";
      } else if (mime.includes("zip") || mime.includes("rar")) {
        return "file-archive-o";
      } else if (mime.includes("ms-excel") || mime.includes("sheet")) {
        return "file-excel-o";
      } else if (
        mime.includes("ms-powerpoint") ||
        mime.includes("presentation")
      ) {
        return "file-powerpoint-o";
      } else if (mime.includes("text/plain")) {
        return "file-text-o";
      } else {
        return "file";
      }
    },
    getEncodedUrl(url) {
      return encodeURIComponent(url);
    },
    onTableFetch(data) {
      this.$emit("fetch", data);
    },

    getTags() {

      TagService.findtags({tags: ['customer', 'vendor', 'colleagues']}).then(response => {

        this.viewers = JsonDenormalizer.denormalize(response);

      });

    },

    async findFile(file) {

      return await FileService.checkLink({link:file.source}).then(response => {

        if (response == 1) {
        
            this.fileToDisplay = 'https://docs.google.com/viewer?url=' + this.getEncodedUrl(file.source) + '&embedded=true';
        
        }else{

          switch(file.type) {

            case 'file-pdf-o': 

                this.fileToDisplay = 'https://docs.google.com/viewer?url=https://file-examples.com/wp-content/uploads/2017/10/file-sample_150kB.pdf&embedded=true'; break;

            case 'file-word-o': 

                this.fileToDisplay = 'https://docs.google.com/viewer?url=https://file-examples.com/wp-content/uploads/2017/02/file-sample_100kB.doc&embedded=true'; break;
            
            case 'file-excel-o': 

                this.fileToDisplay = 'https://docs.google.com/viewer?url=https://file-examples.com/wp-content/uploads/2017/02/file_example_XLS_10.xls&embedded=true'; break;

            case 'file-powerpoint-o': 

                this.fileToDisplay = 'https://docs.google.com/viewer?url=https://file-examples.com/wp-content/uploads/2017/10/file_example_ODP_200kB.odp&embedded=true'; break;

            case 'file-text-o': 

                this.fileToDisplay = 'https://docs.google.com/viewer?url=https://file-examples.com/wp-content/uploads/2017/10/file-sample_100kB.odt&embedded=true'; break;

            default: 

            this.fileToDisplay = 'Test';

          }

        }

        return true;

      });

    },

    async findFile2(file) {

        let response = await FileService.checkLink({link:file.path});
        
        return response;

        // console.log(response);

        // let response = await 

        // event.target.src = row.path
        // // console.log(response);

        // return 'asdasd';

    },
    onTableClick(row) {
      if (this.selected && this.selected.id === row.id) {
        this.selected = null;
      }
    }
  }
};
</script>

<style scoped>
  
.main-image, .thumbnail-image, .generated-image{

  max-width: 100px;

}

/*.invalid-download, .generated-image{

  cursor: not-allowed;

}*/


</style>


// WEBPACK FOOTER //
// src/components/File/FileList.vue